<script context="module">
  export const SINGLE_ROW = "single_row";
  export const SINGLE_COL = "single_col";
  export const DOUBLE_COL = "double_col";
</script>

<script>
  import { createEventDispatcher } from "svelte";
  import { Menu, MenuItem } from "framework7-svelte";

  export let productLayout;

  let menus = [
    { id: SINGLE_ROW, icon: "icon icon-1-row" },
    { id: SINGLE_COL, icon: "icon icon-1-col" },
    { id: DOUBLE_COL, icon: "icon icon-2-col" }
  ];

  function setSelected(value) {
    productLayout.set(value);
  }
</script>

<style>
  :global(.menu-item.selected) {
    background-color: rgb(0, 122, 255);
  }

  :global(.menu-item) {
    background-color: rgba(0, 122, 255, 0.2);
  }
</style>

<div style="position: absolute; right: 0px; margin-top: 10px">
  <Menu>
    {#each menus as menu}
      <MenuItem
        href="?layout={menu.id}"
        icon={menu.icon}
        class={$productLayout === menu.id ? 'selected' : ''}
        value={menu.id}
        on:click={function() {
          setSelected(menu.id);
        }} />
    {/each}
  </Menu>
</div>
